module.exports = __webpack_public_path__ + "img/home-projects.8822410c.svg";